export default __webpack_public_path__ + "static/media/icon-config.96065f2f.svg";